import {createSlice} from "@reduxjs/toolkit";
import {getExpertById,} from "redux/actions/expertsList";
import {ISelectedExpert} from "../../types/redux/expert";

export interface ISelectedExpertPage {
  selectedExpert: ISelectedExpert | null;
  loading: boolean;
}

const initial: ISelectedExpertPage = {
  selectedExpert: null,
  loading: false,
};

export const selectedExpertPageSlice = createSlice({
  name: "selectedExpertPageSlice",
  initialState: initial,
  reducers: {
    clearSelectedExpert(state) {
      state.selectedExpert = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExpertById.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getExpertById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedExpert = action.payload;
    });
    builder.addCase(getExpertById.rejected, (state, action) => {
      state.loading = false;
      state.selectedExpert = null;
    });
  },
});

export const {clearSelectedExpert} = selectedExpertPageSlice.actions;

export default selectedExpertPageSlice.reducer;
